import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { postCreateDevice } from '../services/postCreateDevice.service';

export const createDevice = createAsyncThunk(
  'devices/createDevice',
  async (deviceData, { getState, rejectWithValue }) => {
    const state = getState();

    const selectedProject = selectSelectedProject(state);
    const businessId = selectedProject?.business_id;

    if (!businessId) {
      return rejectWithValue({ message: 'no business id' });
    }

    try {
      const createdDevice = await postCreateDevice(businessId, deviceData);
      return createdDevice;
    } catch (error) {
      return rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || error.message,
      });
    }
  }
);
